import moment from "moment";
import { useNavigate } from "react-router-dom";
import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { useRef } from "react";
import { TrialDetailModal } from "./TrialDetailModal";
import Dropdown from "shared/Components/dropdown";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import Loader from "shared/Components/loader";

export const TrailMobileCard = ({
  data,
  onChangeStatus,
  loadingRowId,
  renderBtn,
}) => {
  const TrailStatus = [
    globalVariables.approve,
    globalVariables.reject,
    globalVariables.pending,
  ];
  const modalRef = useRef();
  const navigate = useNavigate();

  const onOpenDetail = () => {
    navigate(`/admin/trial/reports/${data.id}`, {
      state: { customData: data },
    });
  };

  const onViewMore = (event) => {
    event.stopPropagation();
    modalRef.current.openModal();
  };

  return (
    <div
      onClick={onOpenDetail}
      className="max-w-md mx-auto overflow-hidden bg-white bg-opacity-50 b-bottom py-[15px] border-b-[1px] border-gray-100"
    >
      <div className="flex px-5 justify-between">
        <div className="w-[60%]">
          <h2 className="text-lg leading-tight font-semibold text-gray-800 max-[400px]:text-sm">
            {data?.trial?.trialLocationAddress}
          </h2>
          <p className="text-sm text-gray-500 max-[300px]:text-xs">
            {" "}
            {data?.host?.hostName}
          </p>
        </div>
        <div className="rounded-full h-max flex justify-center px-2 bg-gray-200 bg-opacity-50 border border-gray-200">
          <span className="text-xs w-max py-[2px] text-gray-700">
            {data?.search?.map((search) => search?.level).join(", ")}
          </span>
        </div>
      </div>
      <div className="px-5 mt-2 flex justify-between items-end">
        <div>
          <p className="text-sm text-gray-500 max-[300px]:text-xs">
            {moment.utc(data?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          </p>
        </div>
        <Button
          width="w-[130px] max-[300px]:w-[110px]"
          label={globalVariables.viewMore}
          onClick={(e) => onViewMore(e)}
        />
      </div>
      <Modal ref={modalRef} overflow={"overflow-visible"}>
        <TrialDetailModal
          title={globalVariables.manageTrail}
          date={moment.utc(data?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          location={data?.trial?.trialLocationAddress}
          level={data?.search?.map((search) => search?.level).join(", ")}
          host={data?.host?.hostName}
          openDate={moment.utc(data?.trial?.openDate).format(DEFAULT_DATE_FORMAT)}
          closeDate={moment.utc(data?.trial?.closeDate).format(DEFAULT_DATE_FORMAT)}
          renderButton={() => renderBtn(data.id)}
        />
      </Modal>
    </div>
  );
};
